import React from 'react';
import { AITipsProvider, useAITips } from '../../Context/AITipsContext';
import AITipButton from '../AITipButton/AITipButton';
import AITipCard from '../AITipCard/AITipCard';
import Footer from '../Footer/footer';
import TrialExpiredGate from '../TrialExpiredGate/TrialExpiredGate';
import VersionBanner from '../VersionBanner/VersionBanner';
import { aiTipsConfig } from '../../Utils/aiTipsConfig';

const OnboardingGuide = () => {
  const { showOnboardingGuide, completeOnboarding } = useAITips();
  if (!showOnboardingGuide) return null;
  return (
    <AITipCard
      tips={aiTipsConfig['/dash']}
      onClose={completeOnboarding}
      position="bottom-right"
    />
  );
};

const PageLayout = ({ children }) => {
  return (
    <AITipsProvider>
      <TrialExpiredGate>
        <VersionBanner />
        {children}
        <OnboardingGuide />
        <AITipButton />
        <Footer />
      </TrialExpiredGate>
    </AITipsProvider>
  );
};

export default PageLayout;
